import React from "react";
import Container from 'saur_ui_library/src/Atoms/Container/Container';
import Word from "saur_ui_library/src/Atoms/Word/Word";
import { InputSwitch } from "primereact/inputswitch";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";

const SwitchComponent = (props: any) => {  
  return (
    <Container className={props.className}>
        <Word
          variant="p"
          textStyle="normalBold"
          value={props.title}
          className={props.wordClass}
        />
        <InputSwitch id={props.id} checked={props.checked} onChange={props.onChange} style={props.style}/>
    </Container>
  );
};

export default SwitchComponent;
